module.exports = __webpack_public_path__ + "img/XO.1161fc5f.png";